module.exports = __webpack_public_path__ + "media/images/fa-envelope-e98e479c3a0ea023dfe3c2a8d31bfb5b.png";